"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const systems_1 = require("@/services/systems");
function listEvaluatorsInSystem(systemId) {
    return (0, systems_1.getSystem)(systemId)
        .then((response) => {
        return response.users;
    })
        .catch((error) => {
        return error;
    });
}
exports.default = listEvaluatorsInSystem;
